import { style, styleVariants } from '@vanilla-extract/css';
import { SkeletonVariants } from './Skeleton.types';
import { fadeIn, shimmerAnimation, themeVars } from '@tundr/theme';

export const skeletonClass = style([
  fadeIn,
  {
    display: 'inline-block',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: themeVars.colors.neutrals.grey40,

    selectors: {
      '&::after': {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        transform: 'translateX(-100%)',
        background: `linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, ${themeVars.colors.neutrals.grey30} 50%, rgba(255, 255, 255, 0) 100%)`,
        animation: `${shimmerAnimation} 1.5s ease-in-out infinite`,
        content: '""',
      },
    },
  },
]);

export const skeletonVariantClass = styleVariants({
  [SkeletonVariants.CIRCLE]: {
    width: 80,
    height: 80,
    borderRadius: themeVars.radius.circle,
  },
  [SkeletonVariants.RECTANGLE]: {
    width: '100%',
    minWidth: 200,
    height: 60,
    borderRadius: themeVars.radius.md,
  },
  [SkeletonVariants.TEXT]: {
    width: '100%',
    minWidth: 200,
    height: 16,
    borderRadius: themeVars.radius.sm,
  },
});
